import React from 'react';
import './SalesOverviewCard.css';
import { formatCurrency } from '../utilities/formatCurrency';
import { Calendar, TrendingUp, TrendingDown } from 'lucide-react';

const MonthlySalesOverviewCard = ({ currentMonthSales, currentMonthTests, currentMonthAmount, salesPercentageChange, amountPercentageChange, isLoading = true }) => {
  const today = new Date();
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastMonthName = lastMonth.toLocaleString('default', { month: 'short' });
  const dayOfMonth = today.getDate();
  const comparisonLabel = `vs ${lastMonthName} 1–${dayOfMonth}`;

  return (
    <div className="sales-overview-card">
       <div className="top-right-icon" style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.12), rgba(52,211,153,0.1))' }}>
        <Calendar className="sales-icon" size={22} strokeWidth={2.2} style={{ color: '#059669' }} />
      </div>
      <div className="main-content">
        <div className="title">This Month</div>
        <div className="value-container">
          <div className="value">{isLoading ? <span className="skeleton skeleton-text lg" /> : `${currentMonthSales} Sales`}</div>
          <div className="percentage-change">
              {isLoading ? (
                  <span className="skeleton skeleton-text lg" style={{ width: '60px' }} />
              ) : (
                  salesPercentageChange >= 0 ? (
                      <span className="positive"><TrendingUp className="arrow-icon" size={14} /> {salesPercentageChange.toFixed(1)}%</span>
                  ) : (
                      <span className="negative"><TrendingDown className="arrow-icon" size={14} /> {salesPercentageChange.toFixed(1)}%</span>
                  )
              )}
              {!isLoading && <span style={{ fontSize: 10, color: '#94a3b8', marginLeft: 4 }}>{comparisonLabel}</span>}
          </div>
        </div>
      </div>
      <div className="sub-content-container">
        <div className="sub-content-item">
          <div className="sub-title">Amount</div>
          <div className="value-container">
            <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : formatCurrency(currentMonthAmount.toFixed(2))}</div>
            <div className="percentage-change">
                {isLoading ? (
                    <span className="skeleton skeleton-text lg" style={{ width: '60px' }} />
                ) : (
                    amountPercentageChange >= 0 ? (
                        <span className="positive"><TrendingUp className="arrow-icon" size={12} /> {amountPercentageChange.toFixed(1)}%</span>
                    ) : (
                        <span className="negative"><TrendingDown className="arrow-icon" size={12} /> {amountPercentageChange.toFixed(1)}%</span>
                    )
                )}
                {!isLoading && <span style={{ fontSize: 10, color: '#94a3b8', marginLeft: 4 }}>{comparisonLabel}</span>}
            </div>
          </div>
        </div>
        <div className="sub-content-item">
          <div className="sub-title">Tests</div>
          <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : currentMonthTests}</div>
        </div>
      </div>
    </div>
  );
};

export default MonthlySalesOverviewCard;
